var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107271",
    "data-name": "Group 107271",
    transform: "translate(-6660 -4584)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40435",
    "data-name": "Rectangle 40435",
    width: 20,
    height: 20,
    transform: "translate(6660 4584)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106161",
    "data-name": "Path 106161",
    d: "M20.665,6a3.31,3.31,0,0,0-2.351.967L8.866,16.43a.5.5,0,0,0-.089.089.22.22,0,0,0-.03.03.445.445,0,0,0-.06.06v.015a2.374,2.374,0,0,0,3.452,3.258l7.186-7.2a.474.474,0,1,0-.67-.67L11.47,19.2a1.429,1.429,0,0,1-2.024,0A1.406,1.406,0,0,1,9.4,17.248a.452.452,0,0,0,.045-.06.225.225,0,0,0,.03-.03l.045-.03v-.015L19,7.652A2.367,2.367,0,0,1,22.346,11L10.622,22.724a3.325,3.325,0,0,1-4.7-4.7l9.374-9.374a.476.476,0,1,0-.67-.67L5.251,17.352a4.277,4.277,0,0,0,6.041,6.056L23.031,11.684A3.325,3.325,0,0,0,20.665,6Z",
    transform: "translate(6655.999 4579)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiAttach);
export default __webpack_public_path__ + "static/media/visionai_attach.f7e68536edc9f3741e46e54e8272603d.svg";
export { ForwardRef as ReactComponent };